


  <mat-card>
      <mat-card-header>
         
        @if (assessmentService.isVevo()) {
            <mat-card-title>Australian Employer Details</mat-card-title>
        }
        @else {
            <mat-card-title>Potential Australian Employer Details</mat-card-title>
        }

    </mat-card-header>
    
    <mat-card-content class="m-t-1">
        
            <app-radio-input 
                label="{{ hasOfferLabel() }}" 
                [control]="employerForm.controls.hasOffer"  shortLabel="Has Offer"
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                [errorMsg]="'Please indicate whether you have a job offer'"
                >
            </app-radio-input>
            
            @if (employerForm.controls.hasOffer.value === 'true') {
                <app-text-input label="Company Name" [control]="employerForm.controls.name"></app-text-input>
                <app-text-input label="Australian Business Number (ABN)" [control]="employerForm.controls.abn"></app-text-input>
                
                @if (!assessmentService.isVevoMyself()) {
                    <app-text-input 
                        label="{{ personTerm('First Name')}}" shortLabel="First Name"
                        [control]="employerForm.controls.firstName">
                    </app-text-input>
                    <app-text-input 
                        label="{{ personTerm('Surname / Family Name')}}" shortLabel="Surname"
                        [control]="employerForm.controls.surname">
                    </app-text-input>
                    <app-text-input 
                        label="{{ personTerm('Email')}}" 
                        [control]="employerForm.controls.email" type="email" shortLabel="Email">
                    </app-text-input>
                    <app-phone-input 
                        label="{{ personTerm('best contact phone number')}}" shortLabel="Phone Number"
                        [phoneTypes]="phoneTypes"
                        [phoneTypeControl]="employerForm.controls.phoneType"
                        [phoneCountryCodeControl]="employerForm.controls.phoneCountryCode"
                        [phoneAreaCodeControl]="employerForm.controls.phoneAreaCode"
                        [phoneNumberControl]="employerForm.controls.phoneNumber">
                    </app-phone-input>
                }

                @if (!assessmentService.isVevo()){
                    <app-text-input label="Job title of Position Offered to you" [control]="employerForm.controls.jobTitle" shortLabel="Job Title"></app-text-input>
                    <app-text-input 
                    label="Base Salary" [control]="employerForm.controls.salary" prefix="$" type="number" shortLabel="Base Salary" [errorMsg]="'Numbers only'"></app-text-input>
                    <app-radio-input 
                        label="Can we contact the business on your behalf to further assess your eligibility?"
                        [control]="employerForm.controls.canContact" shortLabel="Can Contact"
                        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
                    </app-radio-input>
                }

            }
    </mat-card-content>
</mat-card>
